import _ from 'lodash'
import { call, put, select, takeLatest } from 'redux-saga/effects'

import VALUES from 'core/data-model/constants/values'
import { isValidAge } from 'core/service/insured/birthdate'
import { UPDATE_BIRTHDATE } from 'quick-quote/insured-information/actions'
import { getAge } from 'quick-quote/insured-information/selectors'
import { SELECTED_PRODUCT } from 'quick-quote/product-selection/actions'
import { getDisplayProducts, getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'

import { selectBasicPlan } from './actions'

/**
 * createProductWholeLifeFunc
 * @param {ReturnType<import('quick-quote/product-common/coverage-plan/sagas').createProductCommonCoverageFunc>} productCommonCoverageFunc
 */
export function createProductWholeLifeFunc(productCommonCoverageFunc) {
  const _getProductByAge = (products, age) => {
    const { value, unit } = age
    return _.find(products, (product) => isValidAge(value, unit, _.get(product, 'entryAge')))
  }

  const _isLifeProtect18Group = (productCode) => _.includes(VALUES.LIFE_PROTECT_18, productCode)
  const _isLifeProtect10Group = (productCode) => _.includes(VALUES.LIFE_PROTECT_10, productCode)
  const _isS73PayGroup = (productCode) => _.includes(VALUES.S7_3PAY, productCode)
  const _isS7SingleGroup = (productCode) => _.includes(VALUES.S7_SINGLE, productCode)

  const _getProductGroupCode = (productCode) => {
    if (_isLifeProtect10Group(productCode)) {
      return VALUES.LIFE_PROTECT_10
    } else if (_isLifeProtect18Group(productCode)) {
      return VALUES.LIFE_PROTECT_18
    } else if (_isS73PayGroup(productCode)) {
      return VALUES.S7_3PAY
    } else if (_isS7SingleGroup(productCode)) {
      return VALUES.S7_SINGLE
    }
  }

  const switchProductByBirthDate = function*() {
    const productCode = yield select(getSelectedDisplayProductCode)
    if (
      !_isLifeProtect18Group(productCode) &&
      !_isLifeProtect10Group(productCode) &&
      !_isS73PayGroup(productCode) &&
      !_isS7SingleGroup(productCode)
    )
      return

    const age = yield select(getAge)
    const products = yield select(getDisplayProducts)
    const productGroupCodes = _getProductGroupCode(productCode)

    const productGroup = _.filter(products, (product) => _.includes(productGroupCodes, _.get(product, 'code')))
    const product = _getProductByAge(productGroup, age)
    if (product !== undefined && productCode !== _.get(product, 'code')) {
      yield put(selectBasicPlan(product))
      yield call(productCommonCoverageFunc.populateAvailableRiders)
    }
  }

  return {
    _getProductByAge,
    switchProductByBirthDate,
  }
}

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* watchers(serviceWrapper) {
  const { WHOLE_LIFE } = serviceWrapper.products
  yield [takeLatest([UPDATE_BIRTHDATE, SELECTED_PRODUCT], WHOLE_LIFE.switchProductByBirthDate)]
}

export const sagas = watchers
